export default __webpack_public_path__ + "static/media/icons8-slides.e58f2da7.svg";